import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReceivingRequestSummaryPageRoutingModule } from './receiving-request-summary-routing.module';

import { ReceivingRequestSummaryPage } from './receiving-request-summary.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReceivingRequestSummaryPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ReceivingRequestSummaryPage]
})
export class ReceivingRequestSummaryPageModule {}
